<template>
  <div class="bg-white rounded-lg shadow-md p-4 max-w-5xl mx-auto">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
        <span class="material-symbols-outlined">movie</span> {{ t('entity.components.videoCreation.preview.title') }} </h2>
      <div class="flex items-center gap-2">
        <CustomButton :button-text="t('entity.components.videoCreation.preview.copyUrl')" icon="content_copy" size="sm" color="neutral" variation="outline" :show-icon="true" :is-disabled="!videoUrl" @click="handleCopyUrl"/>
        <SuggestionButton v-if="videoUrl" :content-id="videoId || 'temp-video-id'" content-model="Video" content-type="VIDEO" content-category="BLOG" :current-video-url="videoUrl" button-text="Video İçin Öneri" icon="auto_fix_high" color="secondary" size="sm" variation="outline"/>
        <CustomButton :button-text="t('entity.components.videoCreation.preview.regenerate')" icon="refresh" size="sm" color="primary" variation="outline" :show-icon="true" @click="$emit('reset')"/>
      </div>
    </div>

    <div class="aspect-video rounded-lg overflow-hidden bg-gray-100 max-h-[600px]">
      <div v-if="videoLoading" class="w-full h-full flex items-center justify-center">
        <div class="text-center">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
          <p class="mt-4 text-sm text-gray-600">{{ t('entity.components.videoCreation.preview.loading') }}</p>
        </div>
      </div>

      <video v-else-if="videoUrl" :src="videoUrl" controls class="w-full h-full object-contain" ref="videoElement">
        {{ t('entity.components.videoCreation.preview.unsupported') }}
      </video>

      <div v-else class="w-full h-full flex items-center justify-center text-gray-500">
        {{ t('entity.components.videoCreation.preview.error') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import CustomButton from '@/components/base/buttons/VButton.vue'
import SuggestionButton from '@/components/suggestions/components/SuggestionButton.vue'
import { responseHandlerService } from '@/plugins/responseHandlerService'

const { t } = useI18n()
const videoElement = ref(null)

const props = defineProps({
  videoUrl: {
    type: String,
    default: '',
  },
  videoLoading: {
    type: Boolean,
    default: false,
  },
  videoId: {
    type: String,
    default: '',
  },
})

defineEmits(['reset'])

const handleCopyUrl = async () => {
  try {
    await navigator.clipboard.writeText(props.videoUrl)
    responseHandlerService.handleSuccess(t('entity.components.videoCreation.preview.urlCopied'))
  } catch (error) {
    responseHandlerService.handleError(t('entity.components.videoCreation.preview.copyError'))
  }
}
</script>